import { extend, configure } from 'vee-validate';
// eslint-disable-next-line @typescript-eslint/camelcase
import { required, digits, email, max, regex, is_not, required_if } from 'vee-validate/dist/rules';
import i18n from '@/i18n';

export default function useValidation() {
    configure({
        defaultMessage: (field, values) => {
            // override the field name.
            values._field_ = i18n.t(`fields.${field}`).toString();

            return i18n.t(`validations.messages.${values._rule_}`, values).toString();
        },
    });

    extend('required', required);
    extend('required_if', required_if);
    extend('max', max);
    extend('email', email);
    extend('digits', digits);
    extend('regex', regex);
    extend('is_not', is_not);
    // extend('required', {
    //     ...required,
    //     // the values param is the placeholders values
    //     message: (_, values) => i18n.t('validations.messages.required', values).toString(),
    // });
    // extend('required_if', {
    //     // eslint-disable-next-line @typescript-eslint/camelcase
    //     ...required_if,
    //     // the values param is the placeholders values
    //     message: (_, values) => i18n.t('validations.messages.required', values).toString(),
    // });
    // extend('max', {
    //     ...max,
    //     // the values param is the placeholders values
    //     message: (_, values) => i18n.t('validations.messages.max', values).toString(),
    // });
    // extend('email', {
    //     ...email,
    //     // the values param is the placeholders values
    //     message: (_, values) => i18n.t('validations.messages.email', values).toString(),
    // });
    // extend('digits', {
    //     ...digits,
    //     // the values param is the placeholders values
    //     message: (_, values) => i18n.t('validations.messages.digits', values).toString(),
    // });
    // extend('regex', {
    //     ...regex,
    //     message: (_, values) => i18n.t('validations.messages.regex', values).toString(),
    // });
    // extend('is_not', {
    //     // eslint-disable-next-line @typescript-eslint/camelcase
    //     ...is_not,
    //     message: (_, values) => i18n.t('validations.messages.required', values).toString(),
    // });
}
